import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 30px;
  width: 440px;
  max-width: 90vw;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-family: 'Inter', sans-serif;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin: 0 0 8px 0;
`;

export const Subtitle = styled.p`
  font-size: 13px;
  color: #666;
  margin: 0 0 24px 0;
  line-height: 1.5;
`;

export const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
`;

export const ItemLabel = styled.span`
  font-size: 13px;
  color: #888;
`;

export const ItemValue = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #333;
  max-width: 60%;
  text-align: right;
`;

export const QtdWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
`;

export const QtdLabel = styled.label`
  font-size: 13px;
  color: #555;
  font-weight: 500;
`;

export const QtdInput = styled.input`
  width: 80px;
  padding: 8px;
  text-align: center;
  border: 1px solid #d0d0d0;
  border-radius: 100px;
  font-size: 14px;
  color: #333;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const CancelButton = styled.button`
  background: none;
  border: 1px solid #0090d3;
  color: #0090d3;
  padding: 10px 20px;
  border-radius: 100px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  background-color: #F75A68;
  border: none;
  color: #ffffff;
  padding: 10px 20px;
  border-radius: 100px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
